import React, { useState } from 'react';
import './Tabs.css';

function Tabs({children}) {
  const [count, setCount] = useState(0);
  return (
    <div className='tabDiv'>
      <div className='tabHeaders'>
        {/* {props.children.map((data, index) => (
          <div
            className={index === count ? 'activeTab' : 'normalTab'}
            onClick={() => {
              setCount(index);
            }}
          >
            {data.props.header}
          </div>
        ))} */}

        <div
            className={'normalTab'}
            style={{width:'100%', borderTopRightRadius: '8px', borderBottomRightRadius:'0px'}}
            onClick={() => {
              setCount(0);
            }}
          >
            {children.props.header}
          </div>
      </div>
      {/* <div className='tabContent'>{props.children[count].props.content}</div> */}
      <div className='tabContent'>{children.props.content}</div>
    </div>
  );
}

export default Tabs;